module.exports = __webpack_public_path__ + "img/faceid.3eb84a5f.png";